import React, { useState, useContext } from 'react';
import { Buffer } from 'buffer';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Multipass } from 'multipass-js';
import NoozApi, { setToken } from '../../services/NoozApi';
import { LocalContext } from '../providers/locale';
import { alertState } from '../recoil/snackbar';
import { UserState } from '../recoil/user';
import { formLabelsState } from '../recoil/formLabels';
import { returnAPISlug } from '../globals';

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

const multipass = new Multipass(process.env.GATSBY_SHOPIFY_MULTIPASS_TOKEN);

export const withAuth = (ComponentToWrap) => (props) => {
  const locale = useContext(LocalContext);

  const [alert, setAlert] = useRecoilState(alertState);
  const [user, setUser] = useRecoilState(UserState);
  const formLabels = useRecoilValue(formLabelsState);

  const [isLoading, setIsLoading] = useState(false);

  const onLoginSubmit = (formData) => {
    setIsLoading(true);

    NoozApi.post('/auth/login', {
      email: formData.email,
      password: formData.password,
    })
      .then((response) => {
        setIsLoading(false);

        if (response.data.customer) {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: formLabels.successLabels,
          });

          setUser(response.data.customer);

          if (typeof window !== 'undefined') {
            window.localStorage.setItem(
              'userToken',
              response.data.token.accessToken
            );
          }

          setToken(response.data.token.accessToken);

          const customerData = {
            email: response.data.customer.email,
          };

          // CREATE A SHOPIFY MULTIPASS LOGIN URL (LOGS THE USER ONTO THE HEADLESS SHOPIFY CHECKOUT)
          const url = multipass
            .withCustomerData(customerData)
            .withDomain(`${process.env.GATSBY_SHOPIFY_SHOP_NAME}.myshopify.com`)
            .withRedirect(
              `${process.env.GATSBY_SHOPIFY_MULTIPASS_REDIRECT_URL}/${process.env.GATSBY_ZONE}/${locale[0]}/account`
            )
            .url();
          // NAVIGATE TO THE MULTIPASS LOGIN URL AND REDIRECT TO THE ACCOUNT PAGE
          window.location.href = url;
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${formLabels.errorLabels} : ${err?.response?.data?.message}`,
        });
      });
  };

  return (
    <ComponentToWrap
      {...props}
      onLoginSubmit={onLoginSubmit}
      isLoading={isLoading}
      user={user}
    />
  );
};
